import { createContext } from "react";

/** Lets the nested report route tell the PDF shell it has finished loading, so printing can start. */
export const ReportLoadedContext = createContext(() => {});
